import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=5145d21c&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=5145d21c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145d21c",
  null
  
)

export default component.exports